import { type RouteObject } from 'react-router-dom';

import { SurveyRootLayout } from './SurveyRootLayout';

export const surveyRoutes: RouteObject = {
  path: 'survey',
  children: [
    {
      element: <SurveyRootLayout />,
      children: [
        {
          path: 'logout',
          lazy: () => import('../../app/logout/page'),
        },
        {
          path: 'questions',
          lazy: () => import('../../app/survey/questions/page'),
        },
        {
          path: 'start',
          lazy: () => import('../../app/survey/start/page'),
        },
        {
          path: 'info',
          lazy: () => import('../../app/survey/info/page'),
        },
        {
          path: 'submit',
          lazy: () => import('../../app/survey/submit/page'),
        },
        {
          path: 'completed',
          lazy: () => import('../../app/survey/completed/page'),
        },
        {
          path: 'expired',
          lazy: () => import('../../app/survey/expired/page'),
        },
        {
          path: 'not-started',
          lazy: () => import('../../app/survey/not-started/page'),
        },
      ],
    },
    {
      path: ':surveyId/company/:companyId/participation/:participationId',
      children: [
        {
          index: true,
          lazy: () => import('../../app/survey/start/page'),
        },
        {
          path: 'start',
          lazy: () => import('../../app/survey/start/page'),
        },
      ],
    },
  ],
};
